import { Tooltip } from '@material-ui/core';
import cx from 'classnames';

import { CustomTypography, TYPOGRAPHY_VARIANT } from 'src/components/CustomTypography';
// @ts-expect-error - TruncatedTypography has no TypeScript declarations
import { TruncatedTypography } from 'src/components/TruncatedTypography';

import styles from './PersonaPainPoints.module.scss';

const DEFAULT_MAX_COUNT = 3;

const stringifyPainPointsTooltip = (painPoints: string[]) => `• ${painPoints.join('\n• ')}`;

interface PersonaPainPointsProps {
  className?: string;
  painPoints?: string[] | null;
  /** How many pain points to show. The rest go into a "+N" tooltip on the last one shown. */
  maxCount?: number;
}

export const PersonaPainPoints = ({
  className,
  painPoints,
  maxCount = DEFAULT_MAX_COUNT,
}: PersonaPainPointsProps) => {
  const items = painPoints ?? [];

  return (
    <div className={className}>
      <CustomTypography
        className={styles.title}
        variant={TYPOGRAPHY_VARIANT.semiBold12}
      >
        Pain points
      </CustomTypography>
      {items.length ? (
        <div>
          {items.slice(0, maxCount).map((painPoint, index) => (
            <div
              key={painPoint}
              className={styles.item}
            >
              <TruncatedTypography
                className={styles.itemText}
                variant={TYPOGRAPHY_VARIANT.regular12}
              >
                {painPoint}
              </TruncatedTypography>
              {items.length > maxCount && index === maxCount - 1 && (
                <Tooltip
                  title={stringifyPainPointsTooltip(items.slice(maxCount))}
                  arrow
                  placement="bottom"
                >
                  <CustomTypography
                    className={cx(styles.itemText, styles.counter)}
                    variant={TYPOGRAPHY_VARIANT.regular12}
                  >
                    +{items.length - maxCount}
                  </CustomTypography>
                </Tooltip>
              )}
            </div>
          ))}
        </div>
      ) : (
        <CustomTypography
          className={styles.empty}
          variant={TYPOGRAPHY_VARIANT.regular12}
        >
          Empty
        </CustomTypography>
      )}
    </div>
  );
};
